import { styled } from "styled-components";
import { Button, Layout } from "antd";

export const VodsLayout = styled(Layout)`
  margin: 0rem 0;
  background-color: transparent;
`;
